import { Card, CardContent } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { promotionsText } from '.'
import plusIcon from '../../../assets/svgs/plus.svg'
import searchIcon from '../../../assets/svgs/search.svg'
import GenericPagination from '../../../components/generic-table/generic-pagination'
import GenericTable from '../../../components/generic-table/generic-table'
import MarketingService from '../../../services/marketingService'
import TableActions from '../TableActions'
import CouponDeleteModal from './CouponDeleteModal'
import CouponModal from './CouponModal'
import DiscountViewModal from './DiscountViewModal'
// Importing these from the original component
import { columns, data } from './data'

const CouponsTable = ({ setCallEnd, venueType, _curCoupon, isRetail }) => {
	const [couponData, setCouponData] = useState([])
	const [showCouponModal, setShowCouponModal] = useState(false)
	const [deleteModal, setDeleteModal] = useState(false)
	const [viewCouponModal, setViewCouponModal] = useState(false)
	const [page, setPage] = useState(0)
	const [rowsPerPage, setRowsPerPage] = useState(10)

	const refreshData = () => {
		if (
			venueType === 'restaurant' ||
			venueType === 'sport_essentials' ||
			venueType === 'pharmacy' ||
			venueType === 'fashion_threads' ||
			venueType === 'home_decor' ||
			venueType === 'online_shop'
		) {
			MarketingService.GetCoupons()
				.then((res) => {
					setCallEnd((v) => ({ ...v, coupon: true }))
					setCouponData(res.data)
				})
				.catch(() => setCallEnd((v) => ({ ...v, coupon: true })))
		}
	}

	const handleCouponChangePage = (event, newPage) => {
		setPage(newPage)
	}

	const handleCouponChangeRowsPerPage = (event) => {
		setRowsPerPage(event)
		setPage(0)
	}

	useEffect(() => {
		refreshData()
	}, [])

	const onView = (row) => {
		_curCoupon.current = row.actions
		setViewCouponModal(!isRetail())
	}

	const onEdit = (row) => {
		_curCoupon.current = row.actions
		setShowCouponModal(true)
	}

	const onDelete = (row) => {
		_curCoupon.current = row.actions
		setDeleteModal(true)
	}

	const handleStatusChange = (row, newStatus) => {
		// If needed, refresh data after status change
		refreshData();
	}

	// Get columns with standard actions column
	const getStandardColumns = () => {
		// Get the original columns
		const originalColumns = columns(promotionsText, venueType, _curCoupon);

		// Make sure we're using the standard 'actions' field name
		return originalColumns;
	};

	// For debugging
	useEffect(() => {
		if (couponData.length > 0) {
			const mappedData = data(couponData);
			console.log("Original coupon data:", couponData[0]);
			console.log("Mapped coupon data:", mappedData[0]);
			console.log("Status value:", couponData[0]?.status);
			console.log("Row actions status:", mappedData[0]?.actions?.status);
		}
	}, [couponData]);


	return (
		<Card className="max-h-[80vh] mt-6">
			<CardContent className="!p-0">
				<div className="flex flex-row justify-between items-center pl-4 pr-3 pt-5">
					<div className="flex flex-row items-center">
						<span className="text-black1 text-xl font-medium">
							{promotionsText('coupons')}
						</span>
						<span className="bg-blue2 text-black1 px-2 rounded-xl ml-2 font-medium">
							{couponData.length} {promotionsText('coupons')}
						</span>
					</div>
					<div
						className="bg-black1 flex flex-row px-6 py-2 text-white rounded-lg cursor-pointer"
						onClick={() => {
							_curCoupon.current = null
							setShowCouponModal(true)
						}}
					>
						<img
							src={plusIcon}
							alt={promotionsText('search')}
							className="mr-2"
						/>
						<span>{promotionsText('add_new_coupon')}</span>
					</div>
				</div>
				{couponData.length > 0 ? (
					<>
						<GenericTable
							data={data(couponData)}
							columns={getStandardColumns()}
							className="!pt-[23px]"
							customActions={(row) => (
								<TableActions
									type="coupon"
									item={row.actions}  // Use row.actions instead of row to get the original data
									onEdit={() => onEdit(row)}
									onDelete={() => onDelete(row)}
									showStatus={true}
									onStatusChange={(newStatus) => handleStatusChange(row, newStatus)}
								/>
							)}
						/>
						<GenericPagination
							count={couponData.length}
							page={page}
							rowsPerPage={rowsPerPage}
							onPageChange={handleCouponChangePage}
							onRowsPerPageChange={handleCouponChangeRowsPerPage}
							setPage={setPage}
							className="!p-2"
						/>
					</>
				) : (
					<div className="flex flex-col items-center text-center py-10 mt-4 border border-x-0">
						<div className="bg-gray7 !p-2 rounded-full">
							<div className="bg-black1 !p-2 rounded-full">
								<img src={searchIcon} alt={promotionsText('search')} />
							</div>
						</div>
						<span className="text-black1 text-lg">
							{promotionsText('no_coupons_found')}
						</span>
						<span className="text-gray5 text-base mt-1">
							{promotionsText('no_coupons_description')}
						</span>
						<div
							className="bg-black1 flex flex-row px-6 py-2 text-white rounded-lg cursor-pointer mt-4"
							onClick={() => {
								_curCoupon.current = null
								setShowCouponModal(true)
							}}
						>
							<img
								src={plusIcon}
								alt={promotionsText('plus')}
								className="mr-2"
							/>
							<span>{promotionsText('add_new_coupon')}</span>
						</div>
					</div>
				)}
			</CardContent>

			{showCouponModal && (
				<CouponModal
					data={_curCoupon.current}
					showModal={showCouponModal}
					onClose={(refresh) => {
						if (refresh === true) {
							refreshData()
						}
						setShowCouponModal(false)
					}}
				/>
			)}

			{viewCouponModal && (
				<DiscountViewModal
					data={_curCoupon.current}
					showModal={viewCouponModal}
					onClose={() => setViewCouponModal(false)}
				/>
			)}

			{deleteModal && (
				<CouponDeleteModal
					data={_curCoupon.current}
					showModal={deleteModal}
					onClose={(refresh) => {
						if (refresh === true) {
							refreshData()
						}
						setDeleteModal(false)
					}}
				/>
			)}
		</Card>
	)
}

export default CouponsTable